<template>
  <div class="container-fluid">
    <stock-movement-form
      :loading="loading"
      :stockMovementData="stockMovement"
      :formErrors="formErrors"
      @stockMovementSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultStockMovement from "../defaultStockMovement";
import StockMovementForm from "../partials/StockMovementForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    StockMovementForm,
  },

  mixins: [alertLeave],

  data() {
    const stockMovement = cloneDeep(defaultStockMovement);
    if (this.$currentUserIsLevelOrganization()) {
      stockMovement.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      stockMovement: stockMovement,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(stockMovement) {
      this.loading = true;

      const stockMovementData = cloneDeep(stockMovement);
      delete stockMovementData.id;

      try {
        await this.$store.dispatch("stockMovements/add", stockMovementData);
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.PRODUCT_ADDED"),
        });
        const stockMovement =
          this.$store.getters["stockMovements/stockMovement"];
        this.$emit("onViewStockMovement", stockMovement, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
